import { bindTypesToActions } from '@src/utils/redux_utils';
import localStore from '@src/utils/storage';
// import { getEligibleLevel } from '@src/utils/levels';

export const types = {
  //saga actions:
  FetchProfiles: 'PROFILE_FETCH_PROFILES',
  CreateProfile: 'PROFILE_CREATE_PROFILE',
  //reducer actions:
  SetProfiles: 'PROFILE_SET_PROFILES',
  UpdateProfile: 'PROFILE_UPDATE_PROFILE',
  UpdateProfileAvatar : 'PROFILE_UPDATE_AVATAR',
  SelectProfile: 'PROFILE_CHOOSE_PROFILE',
  SetLocalProfile: 'PROFILE_SET_LOCAL_DATA',
  SetDisabledLevels:'SET_DISABLED_LEVELS'
};

const profileActions = bindTypesToActions(types);

let getInitialState = () => ({
  profiles: [],
  selected: null, //profileid
});

const profileReducer = (state = getInitialState(), { type, payload }) => {
  switch (type) {
    case types.SetProfiles: // set profiles property directly.
      const { profiles } = payload ?? {};

      if (!Array.isArray(profiles)) return state;

      return { ...state, profiles };

    case types.UpdateProfile: // updates a profile after matching with profileid.
      const { profile: profileChunk } = payload ?? {};


      if (profileChunk) {
        return {
          ...state,
          profiles: state.profiles.map((stateProfile) =>
            stateProfile.profileid === profileChunk.profileid
              ? { ...stateProfile, ...profileChunk }
              : stateProfile
          ),
        };
      }
      break;
    case types.SetDisabledLevels :
      const { profile: profileChunkk,disabledLevels } = payload ?? {};
      if(profileChunkk && disabledLevels) {
        
        return {
          ...state,
          profiles: state.profiles.map((stateProfile) =>
            stateProfile.profileid === profileChunkk.profileid
              ? { ...stateProfile, disabledLevels }
              : stateProfile
          ),
        };
      }

    break;
    case types.SelectProfile: // profile is selected for default load on Home. Also stored in localStorage.
      const { profileid } = payload ?? {};
      let profile = state.profiles.find(
        (profile) => profile.profileid === profileid
      );
      if (!profile) return state;

      const localData = localStore.get( '__profiles' )?.[ profileid ];  
      const currentLevel = localData?.currentLevel ;
      
      if ( !profile.currentLevel && currentLevel ) profile = { ...profile, currentLevel };
      localStore.set( '__selectedProfile', profileid );

      return {
        ...state,
        selected: profileid,
        profiles: state.profiles.map((entry) =>
          entry.profileid === profileid ? profile : entry
        ),
      };

    case types.SetLocalProfile:
      return setProfileData(state, payload);
    
      break;
 
     case types.UpdateProfileAvatar: // updates a profileAvatar after matching with profileid.
     const { profile: profileChunkkk } = payload ?? {};
     if (profileChunkkk) {
       return {
         ...state,
         profiles: state.profiles.map((stateProfile) =>
           stateProfile.profileid === profileChunkkk.profileid
             ? { ...stateProfile, ...profileChunkkk }
             : stateProfile
         ),
       };
     }
     break;

    case 'LOG_OUT_ALL':
      localStore.remove('__selectedProfile');
      localStore.remove('__profiles');
      return getInitialState();

    default:
      return state;
  }
  return state;
};

function setProfileData(state, payload) {
  const { profileid, ...data } = payload;

  const localData = localStore.get('__profiles') ?? {};

  const profileData = { ...(localData[profileid] ?? null), ...data };

  localData[profileid] = profileData;

  localStore.set('__profiles', localData);

  return {
    ...state,
    profiles: state.profiles.map((profile) => {
      if (profile.profileid === profileid)
        return { ...profile, ...profileData };
      return profile;
    }),
  };
}

export { types as profileTypes, profileReducer, profileActions };
